/**
 *
 * Usage
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * get(object, 'a[0].b.c'); // => 3
 *
 * get(object, ['a', '0', 'b', 'c']); // => 3
 *
 * get(object, 'a.b.c', 'default'); // => 'default'
 *
 */

import lodashGet from 'lodash.get';

// Keep helper broadly typed to match existing dynamic usage across the app.
function get<T = any>(object: any, path: string | string[], defaultValue?: any): T {
    return lodashGet(object, path as any, defaultValue) as T;
}

export default get;
